import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-externalsite-alert',
  templateUrl: './externalsite-alert.component.html',
  styleUrls: ['./externalsite-alert.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExternalsiteAlertComponent implements OnInit {
  @Input() public eventReference;
  constructor(private readonly modalService: NgbModal) {}

  ngOnInit(): void {}
  redirectto() {
    window.open(this.eventReference);
    this.modalService.dismissAll();
  }
  dismissModal() {
    this.modalService.dismissAll();
  }
}
